import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import translations from './translations';

const LanguageContext = createContext({
  lang: 'fr',
  setLang: () => {},
  t: (key) => key,
});

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('linx-lang') || 'fr';
    } catch {
      return 'fr';
    }
  });

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    try {
      localStorage.setItem('linx-lang', newLang);
      document.documentElement.lang = newLang;
    } catch {
      // localStorage unavailable
    }
  }, []);

  const t = useCallback(
    (key) => {
      const entry = translations[key];
      if (!entry) return key;
      return entry[lang] || entry.fr || key;
    },
    [lang],
  );

  // Sync <html dir> for Arabic RTL
  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang: changeLang, t }),
    [lang, changeLang, t],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}

export default LanguageContext;
